<template>

  <div v-if=" Badge === 'Icon' "  @mouseover="showOptions = true" @mouseleave="showOptions = false" class="flex items-center">
    <svg  class="w-5 h-5 text-green-800" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="19.5234" y="19.5239" width="19.5238" height="19.5238" rx="9.76191" transform="rotate(-180 19.5234 19.5239)" fill="#F2FFF0"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.39541 6.60854C6.39541 6.20665 6.7212 5.88086 7.12308 5.88086L12.9546 5.88086C13.3565 5.88086 13.6823 6.20665 13.6823 6.60854L13.6823 12.4401C13.6823 12.842 13.3565 13.1677 12.9546 13.1677C12.5527 13.1677 12.2269 12.842 12.2269 12.4401L12.2269 8.36531L7.12308 13.4692C6.83891 13.7533 6.37817 13.7533 6.09399 13.4692C5.80981 13.185 5.80981 12.7242 6.09399 12.4401L11.1978 7.33622L7.12308 7.33622C6.7212 7.33622 6.39541 7.01042 6.39541 6.60854Z" fill="#306E24"/>
    </svg>

    <p class="text-green-800 cb-text-copy-small font-medium ">13.5% ($16.7M)</p>    

  </div>
  
  <div @mouseover="showOptions = true" @mouseleave="showOptions = false" v-if=" Badge === 'text'" class="badge badge-small bg-green-100 text-neutral-800 py-1 px-3 max-h-5">
    <p class="text-green-800 font-medium " v-if=" Badge === 'text'">{{text}}</p>    
  </div>

  <div  v-if=" Badge === 'Icon'" class="relative right-3" v-show="showOptions">
      <div class="absolute top-[-6px] left-28 z-10 !w-[250px] p-2 -mt-1 cb-text-copy-regular leading-tight !bg-gray-900 text-white rounded-md transform -translate-x-1/2 -translate-y-[46px] shadow-lg">
        Comparison of the previous period
      </div>
      <svg class="absolute z-10 w-6 h-6 text-gray-900 transform -translate-x-[-48px] -translate-y-[30px] fill-current stroke-current" width="8" height="8">
        <rect x="12" y="-10" width="8" height="8" transform="rotate(45)" />
      </svg>
    </div>

</template>

<script>
export default {
  name: "CompareBadge",
  props: {
    Badge: {
      type: String,
      default: 'Icon'
    },
    text: String
  },
  data() {
        return {
            showOptions: false
        }
    }
};
</script>